const translations: Record<string, string> = {
  "nav.home": "Strona Główna",
  "nav.categories": "Kategorie",
  "nav.safety": "Bezpieczeństwo",
  "nav.blog": "Blog",
  "nav.faq": "FAQ",
  "nav.all_categories": "Wszystkie Kategorie",

  "hero.h1": "Kakobuy Spreadsheet Polska",
  "hero.subtitle": "Najlepsze listy produktów, znalezione okazje i przewodniki zakupowe Kakobuy w jednym miejscu.",
  "hero.cta_primary": "Sprawdź Kakobuy Spreadsheet",
  "hero.cta_secondary": "Dowiedz się, czy Kakobuy jest bezpieczny",
  "hero.trust_1": "Aktualizowane listy produktów",
  "hero.trust_2": "Przewodniki dla początkujących",
  "hero.trust_3": "Analizy bezpieczeństwa",
  "hero.trust_4": "Kategorie premium",

  "stats.products": "Produktów w bazie",
  "stats.guides": "Przewodników",
  "stats.categories": "Kategorii",

  "what_is.title": "Czym jest Kakobuy Spreadsheet?",
  "what_is.p1": "Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć najlepsze produkty, porównać opcje i podejmować bardziej świadome decyzje zakupowe.",
  "what_is.p2": "Zamiast przeszukiwać setki losowych stron, możesz korzystać z gotowych kategorii, rankingów oraz aktualnych list produktów. To narzędzie stworzone przez społeczność dla społeczności – każdy może znaleźć to, czego szuka, bez marnowania czasu na niepotrzebne przeglądanie.",
  "what_is.p3": "Niezależnie od tego, czy szukasz sneakersów, ubrań, akcesoriów czy innych produktów – Kakobuy Spreadsheet oferuje przejrzysty i łatwy w obsłudze system kategorii, który prowadzi Cię prosto do celu.",

  "compare.title": "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  "compare.col_method": "Metoda",
  "compare.col_time": "Czas wyszukiwania",
  "compare.col_risk": "Ryzyko błędu",
  "compare.col_comfort": "Wygoda",
  "compare.row1_method": "Losowe wyszukiwanie",
  "compare.row1_time": "Długi",
  "compare.row2_method": "Samodzielne porównywanie",
  "compare.row2_time": "Średni",
  "compare.row3_method": "Kakobuy Spreadsheet",
  "compare.row3_time": "Krótki",

  "categories.title": "Najpopularniejsze kategorie Kakobuy Spreadsheet",
  "categories.subtitle": "Przeglądaj produkty według kategorii i znajdź dokładnie to, czego potrzebujesz. Każda kategoria zawiera starannie wyselekcjonowane produkty z aktualnych list.",

  "why_us.title": "Dlaczego użytkownicy wybierają KakobuyPolska.skin?",
  "why_us.p1": "Naszym celem jest stworzenie największej polskiej bazy wiedzy dotyczącej Kakobuy Spreadsheet. Publikujemy szczegółowe przewodniki, porównania produktów, informacje o bezpieczeństwie oraz praktyczne instrukcje.",
  "why_us.point1": "Szczegółowe przewodniki zakupowe",
  "why_us.point2": "Porównania produktów i kategorii",
  "why_us.point3": "Informacje o bezpieczeństwie transakcji",
  "why_us.point4": "Praktyczne instrukcje krok po kroku",

  "safety.title": "Czy Kakobuy jest bezpieczny?",
  "safety.p1": "Przed zakupem zawsze warto sprawdzić kilka kluczowych elementów, które zapewnią Ci bezpieczną i udaną transakcję.",
  "safety.check1": "Informacje o sprzedawcy",
  "safety.check2": "Zdjęcia QC (kontrola jakości)",
  "safety.check3": "Opinie użytkowników",
  "safety.check4": "Metody płatności",
  "safety.check5": "Koszty wysyłki",
  "safety.cta": "Sprawdź poradnik bezpieczeństwa",

  "featured.title": "Polecane produkty Kakobuy Spreadsheet",
  "featured.col_product": "Produkt",
  "featured.col_category": "Kategoria",
  "featured.col_popularity": "Popularność",
  "featured.col_rating": "Ocena",

  "faq.title": "Najczęściej Zadawane Pytania",
  "faq.q1": "Czym jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to lista produktów i przewodników, które pomagają szybciej znaleźć interesujące produkty. To uporządkowana baza danych tworzona przez społeczność, która ułatwia wyszukiwanie i porównywanie produktów z różnych kategorii.",
  "faq.q2": "Czy Kakobuy Spreadsheet jest darmowy?",
  "faq.a2": "Dostępność list zależy od źródła. Nasza strona pomaga użytkownikom znaleźć informacje i korzystać z nich efektywnie, bez dodatkowych opłat.",
  "faq.q3": "Czy Kakobuy jest bezpieczny?",
  "faq.a3": "Bezpieczeństwo zależy od sposobu korzystania. Zawsze należy sprawdzać sprzedawców, opinie oraz informacje o produkcie przed dokonaniem zakupu. Zalecamy również korzystanie z bezpiecznych metod płatności i dokładne czytanie opisów produktów.",
  "faq.q4": "Jak często aktualizowane są listy produktów?",
  "faq.a4": "Listy produktów Kakobuy Spreadsheet są regularnie aktualizowane przez społeczność. Nowe produkty i kategorie są dodawane na bieżąco, aby zapewnić dostęp do najbardziej aktualnych informacji.",
  "faq.q5": "Jakie kategorie produktów są dostępne?",
  "faq.a5": "Kakobuy Spreadsheet obejmuje szeroki zakres kategorii, w tym sneakersy, odzież (bluzy, t-shirty, kurtki, spodnie), akcesoria, torby, paski, perfumy i wiele więcej. Pełną listę kategorii znajdziesz w sekcji kategorii na naszej stronie.",

  "articles.title": "Najnowsze Artykuły i Poradniki",
  "articles.subtitle": "Poznaj szczegółowe przewodniki i analizy dotyczące Kakobuy Spreadsheet",
  "articles.read_more": "Czytaj więcej",

  "cta.title": "Gotowy, aby odkryć najlepsze produkty?",
  "cta.subtitle": "Przejdź do Kakobuy Spreadsheet i rozpocznij wyszukiwanie już teraz.",
  "cta.button1": "Kakobuy Spreadsheet",
  "cta.button2": "Kup Teraz",

  "footer.description": "Największa polska baza wiedzy o Kakobuy Spreadsheet. Znajdź najlepsze produkty, poradniki i analizy bezpieczeństwa.",
  "footer.quick_links": "Szybkie Linki",
  "footer.categories_title": "Kategorie",
  "footer.resources": "Zasoby",
  "footer.copyright": "Wszelkie prawa zastrzeżone.",

  "article.back_home": "← Powrót do strony głównej",
  "article.related": "Powiązane artykuły",
  "article.table_of_contents": "Spis treści",
};

export default translations;